// GENERATED FILE — do not edit by hand.
// Regenerate with `pnpm generate:dw-types` (see codeGeneration/generateDwTypes.mjs).
// Sources: the backend's declared collection schema (?operation=options) and
// codeGeneration/dw-field-types.json (types inferred from the backend source).
//
// Shape notes:
// - Documents are the post-projection shape pipelines see: scalar usages as
//   nested objects, list usages as arrays of plain objects.
// - A field the sync could not resolve is DROPPED from the document, so
//   absent and null read alike — every field is optional AND nullable.
// - Dates/datetimes serialize as ISO strings WITHOUT milliseconds/offset
//   (parse as UTC yourself; an offset-less string parses as LOCAL time).

export interface SpacesSpace {
  ct_identifier?: string | null;
  id?: string | null;
  organization_id?: string | null;
  apartment_id?: string | null;
  landlord_custom_id?: string | null;
  popular_name?: string | null;
  category?: string | null;
  address_id?: string | null;
  structure_id?: string | null;
  usable_area?: number | null;
  bi_area?: number | null;
  floors?: number[] | null;
  room_count?: number | null;
  first_floor?: number | null;
  tempered_area?: number | null;
  has_base_rent_vat?: boolean | null;
  status?: number | null;
  financial_handler_id?: string | null;
}

export interface SpacesAddress {
  id?: string | null;
  verbose_name?: string | null;
  street?: string | null;
  street_number?: string | null;
  postal_code?: string | null;
  city?: string | null;
  country?: string | null;
  longitude?: number | null;
  latitude?: number | null;
  street_with_city?: string | null;
}

export interface SpacesLandlord {
  id?: string | null;
  name?: string | null;
  org_no?: string | null;
  sni_number?: string | null;
  custom_id?: string | null;
  invoice_identifier?: number | null;
  postal_address_id?: string | null;
  visiting_address_id?: string | null;
  registered_address_id?: string | null;
}

export interface SpacesRealestate {
  id?: string | null;
  name?: string | null;
  popular_name?: string | null;
  landlord_id?: string | null;
  community_id?: string | null;
  primary_financial_handler_id?: string | null;
  financial_responsibility_from?: string | null;
  financial_responsibility_to?: string | null;
}

export interface SpacesCommunity {
  id?: string | null;
  name?: string | null;
  sales_description?: string | null;
  region_id?: string | null;
  main_address_id?: string | null;
}

export interface SpacesRegion {
  id?: string | null;
  name?: string | null;
}

export interface SpacesStructure {
  ct_identifier?: string | null;
  id?: string | null;
  name?: string | null;
  realestate_id?: string | null;
}

export interface SpacesRoom {
  id?: string | null;
  name?: string | null;
  space_id?: string | null;
}

export interface SpacesComponent {
  id?: string | null;
  name?: string | null;
  room_id?: string | null;
  space_id?: string | null;
  structure_id?: string | null;
  realestate_id?: string | null;
  component_type_id?: string | null;
  component_model_id?: string | null;
}

export interface SpacesContract {
  ct_identifier?: string | null;
  id?: string | null;
  organization_id?: string | null;
  id_number?: string | null;
  is_draft?: boolean | null;
  archived?: boolean | null;
  start_date?: string | null;
  signed_time?: string | null;
  initial_end_date?: string | null;
  renewed_to?: string | null;
  lifetime_end_date?: string | null;
  last_owner_notification_date?: string | null;
  last_counterpart_notification_date?: string | null;
  status?: number | null;
  counterpart_notification_interval_weeks?: number | null;
  owner_notification_interval_weeks?: number | null;
  renew_interval_weeks?: number | null;
  cancellation_time?: string | null;
  cancellation_signed_time?: string | null;
  cancelled_by_counterpart?: boolean | null;
  pending_re_negotiations?: boolean | null;
  invoicing_default_vat?: number | null;
  invoicing_period?: number | null;
  invoice_month_interval?: number | null;
  invoicing_period_from?: string | null;
  invoicing_automatic_creation_paused?: boolean | null;
  eligible_for_invoicing?: boolean | null;
  invoicing_company_id?: string | null;
  invoicing_contract_setting_id?: string | null;
  invoicing_payment_terms_id?: string | null;
  main_realestate_id?: string | null;
  space_controlled_setting_marker?: string | null;
  space_id?: string | null;
  space_ids?: string[] | null;
  main_invoiceable_id?: string | null;
  main_invoiceable_ct_identifier?: string | null;
  tenant_id?: string | null;
  bi_tenant_ids?: string[] | null;
}

export interface SpacesTenant {
  id?: string | null;
  ct_identifier?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  corporate_name?: string | null;
  phone_number?: string | null;
  email?: string | null;
  ssn?: string | null;
  org_no?: string | null;
  status?: number | null;
}

export interface SpacesRevenueRow {
  ct_identifier?: string | null;
  id?: string | null;
  organization_id?: string | null;
  article_id?: string | null;
  value?: number | null;
  start_date?: string | null;
  end_date?: string | null;
  excempt_from_months?: number[] | null;
  space_id?: string | null;
  contract_id?: string | null;
  is_indexation_row?: boolean | null;
  is_retroactive_revenue_row?: boolean | null;
  is_renovation_notation_row?: boolean | null;
  is_customer_earnings_row?: boolean | null;
  is_measurements_row?: boolean | null;
  is_quote_fee_row?: boolean | null;
}

export interface SpacesVacancyNotation {
  ct_identifier?: string | null;
  id?: string | null;
  space_id?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  annulled?: boolean | null;
}

export interface SpacesVacancyLossNotation {
  ct_identifier?: string | null;
  id?: string | null;
  vacancy_notation_id?: string | null;
  article_id?: string | null;
  value?: number | null;
  vat?: number | null;
  start_date?: string | null;
  end_date?: string | null;
}

export interface SpacesArticle {
  id?: string | null;
  category_id?: string | null;
  name?: string | null;
  vat?: number | null;
  ignore_dynamicly_calculated_vat?: boolean | null;
  disable_debiting?: boolean | null;
}

export interface SpacesArticleCategory {
  id?: string | null;
  name?: string | null;
  consider_base_rent?: boolean | null;
}

export interface SpacesTagUsage {
  id?: string | null;
  tag_id?: string | null;
  object_id?: string | null;
  content_type_id?: number | null;
  value?: string | null;
  start_date?: string | null;
  end_date?: string | null;
}

export interface SpacesTag {
  id?: string | null;
  name?: string | null;
}

export interface SpacesDocument {
  /** MongoDB document id. */
  _id?: string;
  space?: SpacesSpace | null;
  address?: SpacesAddress | null;
  landlord?: SpacesLandlord | null;
  realestate?: SpacesRealestate | null;
  community?: SpacesCommunity | null;
  region?: SpacesRegion | null;
  structure?: SpacesStructure | null;
  rooms?: SpacesRoom[] | null;
  components?: SpacesComponent[] | null;
  contracts?: SpacesContract[] | null;
  tenants?: SpacesTenant[] | null;
  revenue_rows?: SpacesRevenueRow[] | null;
  vacancy_notations?: SpacesVacancyNotation[] | null;
  vacancy_loss_notations?: SpacesVacancyLossNotation[] | null;
  articles?: SpacesArticle[] | null;
  article_categories?: SpacesArticleCategory[] | null;
  tag_usages?: SpacesTagUsage[] | null;
  tags?: SpacesTag[] | null;
}

export type SpacesFieldPath =
  | 'space.ct_identifier'
  | 'space.id'
  | 'space.organization_id'
  | 'space.apartment_id'
  | 'space.landlord_custom_id'
  | 'space.popular_name'
  | 'space.category'
  | 'space.address_id'
  | 'space.structure_id'
  | 'space.usable_area'
  | 'space.bi_area'
  | 'space.floors'
  | 'space.room_count'
  | 'space.first_floor'
  | 'space.tempered_area'
  | 'space.has_base_rent_vat'
  | 'space.status'
  | 'space.financial_handler_id'
  | 'space'
  | 'address.id'
  | 'address.verbose_name'
  | 'address.street'
  | 'address.street_number'
  | 'address.postal_code'
  | 'address.city'
  | 'address.country'
  | 'address.longitude'
  | 'address.latitude'
  | 'address.street_with_city'
  | 'address'
  | 'landlord.id'
  | 'landlord.name'
  | 'landlord.org_no'
  | 'landlord.sni_number'
  | 'landlord.custom_id'
  | 'landlord.invoice_identifier'
  | 'landlord.postal_address_id'
  | 'landlord.visiting_address_id'
  | 'landlord.registered_address_id'
  | 'landlord'
  | 'realestate.id'
  | 'realestate.name'
  | 'realestate.popular_name'
  | 'realestate.landlord_id'
  | 'realestate.community_id'
  | 'realestate.primary_financial_handler_id'
  | 'realestate.financial_responsibility_from'
  | 'realestate.financial_responsibility_to'
  | 'realestate'
  | 'community.id'
  | 'community.name'
  | 'community.sales_description'
  | 'community.region_id'
  | 'community.main_address_id'
  | 'community'
  | 'region.id'
  | 'region.name'
  | 'region'
  | 'structure.ct_identifier'
  | 'structure.id'
  | 'structure.name'
  | 'structure.realestate_id'
  | 'structure'
  | 'rooms.id'
  | 'rooms.name'
  | 'rooms.space_id'
  | 'rooms'
  | 'components.id'
  | 'components.name'
  | 'components.room_id'
  | 'components.space_id'
  | 'components.structure_id'
  | 'components.realestate_id'
  | 'components.component_type_id'
  | 'components.component_model_id'
  | 'components'
  | 'contracts.ct_identifier'
  | 'contracts.id'
  | 'contracts.organization_id'
  | 'contracts.id_number'
  | 'contracts.is_draft'
  | 'contracts.archived'
  | 'contracts.start_date'
  | 'contracts.signed_time'
  | 'contracts.initial_end_date'
  | 'contracts.renewed_to'
  | 'contracts.lifetime_end_date'
  | 'contracts.last_owner_notification_date'
  | 'contracts.last_counterpart_notification_date'
  | 'contracts.status'
  | 'contracts.counterpart_notification_interval_weeks'
  | 'contracts.owner_notification_interval_weeks'
  | 'contracts.renew_interval_weeks'
  | 'contracts.cancellation_time'
  | 'contracts.cancellation_signed_time'
  | 'contracts.cancelled_by_counterpart'
  | 'contracts.pending_re_negotiations'
  | 'contracts.invoicing_default_vat'
  | 'contracts.invoicing_period'
  | 'contracts.invoice_month_interval'
  | 'contracts.invoicing_period_from'
  | 'contracts.invoicing_automatic_creation_paused'
  | 'contracts.eligible_for_invoicing'
  | 'contracts.invoicing_company_id'
  | 'contracts.invoicing_contract_setting_id'
  | 'contracts.invoicing_payment_terms_id'
  | 'contracts.main_realestate_id'
  | 'contracts.space_controlled_setting_marker'
  | 'contracts.space_id'
  | 'contracts.space_ids'
  | 'contracts.main_invoiceable_id'
  | 'contracts.main_invoiceable_ct_identifier'
  | 'contracts.tenant_id'
  | 'contracts.bi_tenant_ids'
  | 'contracts'
  | 'tenants.id'
  | 'tenants.ct_identifier'
  | 'tenants.first_name'
  | 'tenants.last_name'
  | 'tenants.corporate_name'
  | 'tenants.phone_number'
  | 'tenants.email'
  | 'tenants.ssn'
  | 'tenants.org_no'
  | 'tenants.status'
  | 'tenants'
  | 'revenue_rows.ct_identifier'
  | 'revenue_rows.id'
  | 'revenue_rows.organization_id'
  | 'revenue_rows.article_id'
  | 'revenue_rows.value'
  | 'revenue_rows.start_date'
  | 'revenue_rows.end_date'
  | 'revenue_rows.excempt_from_months'
  | 'revenue_rows.space_id'
  | 'revenue_rows.contract_id'
  | 'revenue_rows.is_indexation_row'
  | 'revenue_rows.is_retroactive_revenue_row'
  | 'revenue_rows.is_renovation_notation_row'
  | 'revenue_rows.is_customer_earnings_row'
  | 'revenue_rows.is_measurements_row'
  | 'revenue_rows.is_quote_fee_row'
  | 'revenue_rows'
  | 'vacancy_notations.ct_identifier'
  | 'vacancy_notations.id'
  | 'vacancy_notations.space_id'
  | 'vacancy_notations.start_date'
  | 'vacancy_notations.end_date'
  | 'vacancy_notations.annulled'
  | 'vacancy_notations'
  | 'vacancy_loss_notations.ct_identifier'
  | 'vacancy_loss_notations.id'
  | 'vacancy_loss_notations.vacancy_notation_id'
  | 'vacancy_loss_notations.article_id'
  | 'vacancy_loss_notations.value'
  | 'vacancy_loss_notations.vat'
  | 'vacancy_loss_notations.start_date'
  | 'vacancy_loss_notations.end_date'
  | 'vacancy_loss_notations'
  | 'articles.id'
  | 'articles.category_id'
  | 'articles.name'
  | 'articles.vat'
  | 'articles.ignore_dynamicly_calculated_vat'
  | 'articles.disable_debiting'
  | 'articles'
  | 'article_categories.id'
  | 'article_categories.name'
  | 'article_categories.consider_base_rent'
  | 'article_categories'
  | 'tag_usages.id'
  | 'tag_usages.tag_id'
  | 'tag_usages.object_id'
  | 'tag_usages.content_type_id'
  | 'tag_usages.value'
  | 'tag_usages.start_date'
  | 'tag_usages.end_date'
  | 'tag_usages'
  | 'tags.id'
  | 'tags.name'
  | 'tags';

/** Paths eligible for `additional_match_stage` (no list usage on the way). */
export type SpacesMatchPath =
  | 'space.ct_identifier'
  | 'space.id'
  | 'space.apartment_id'
  | 'space.landlord_custom_id'
  | 'space.popular_name'
  | 'space.category'
  | 'space.address_id'
  | 'space.structure_id'
  | 'space.usable_area'
  | 'space.bi_area'
  | 'space.floors'
  | 'space.room_count'
  | 'space.first_floor'
  | 'space.tempered_area'
  | 'space.has_base_rent_vat'
  | 'space.status'
  | 'space.financial_handler_id'
  | 'address.id'
  | 'address.verbose_name'
  | 'address.street'
  | 'address.street_number'
  | 'address.postal_code'
  | 'address.city'
  | 'address.country'
  | 'address.longitude'
  | 'address.latitude'
  | 'address.street_with_city'
  | 'landlord.id'
  | 'landlord.name'
  | 'landlord.org_no'
  | 'landlord.sni_number'
  | 'landlord.custom_id'
  | 'landlord.invoice_identifier'
  | 'landlord.postal_address_id'
  | 'landlord.visiting_address_id'
  | 'landlord.registered_address_id'
  | 'realestate.id'
  | 'realestate.name'
  | 'realestate.popular_name'
  | 'realestate.landlord_id'
  | 'realestate.community_id'
  | 'realestate.primary_financial_handler_id'
  | 'realestate.financial_responsibility_from'
  | 'realestate.financial_responsibility_to'
  | 'community.id'
  | 'community.name'
  | 'community.sales_description'
  | 'community.region_id'
  | 'community.main_address_id'
  | 'region.id'
  | 'region.name'
  | 'structure.ct_identifier'
  | 'structure.id'
  | 'structure.name'
  | 'structure.realestate_id';

/** Compile-checked field path for Spaces pipelines. */
export const spacesField = <P extends SpacesFieldPath>(p: P): P => p;

/** Compile-checked additional_match_stage path for Spaces. */
export const spacesMatchField = <P extends SpacesMatchPath>(p: P): P => p;

/** Compile-checked `$`-prefixed field reference for Spaces pipeline expressions. */
export const spacesRef = <P extends SpacesFieldPath>(p: P): `$${P}` => `$${p}`;
